import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5.072a8 8 0 1 1 -3.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 3.995 -6.643z","key":"svg-0"}]]

const IconPlayerRecordFilled = createReactComponent('filled', 'player-record-filled', 'PlayerRecordFilled', __iconNode);

export default IconPlayerRecordFilled;